<template>
  <div>
    <div class="page-title">{{pageTitle}}</div>
    <div class="page-header">
      <page-tab :tabs="tabs" :nowTab="nowTab"></page-tab>
      <multi-search ref="multiSearch" @updateTable="updateTable" @updateRule="updateRule"></multi-search>
      <filter-com ref="filterCom"
        v-if="curTableId !== ''"
        :fields="fields"
        @confirmFilter="confirmFilter"
        @toggleFilterShow="toggleFilterShow"></filter-com>
    </div>
    <div class="page-content" ref="pageContent">
      <template v-if="curTableId !== ''">
        <div class="page-table-addon">
          <div class="table-data-count">共<span>{{tableDataCount}}</span>条数据</div>
          <div class="table-ope">
            <div class="table-fresh link-btn" @click.stop="getTableData">
              <i class="yjh-icon icon-fresh"></i>手动刷新
            </div>
            <div class="table-restore link-btn" v-if="pageType==='unsureClean' && curRuleId !== ''" @click.stop="restore(selArr)">
              <i class="yjh-icon icon-restore"></i>批量还原
            </div>
          </div>
        </div>
        <page-table
          :class="{'disabled-sel': disableSel}"
          ref="table"
          v-loading="tableLoading"
          :loading="tableLoading"
          :col="tableCol"
          :data="tableData"
          :pageSize="30"
          :selectAll="selectAll"
          :selectChange="selectChange"
          @compFn="compFn"
        ></page-table>
      </template>
      <template v-else>
        <div class="no-table" :style="{height: blockHeight}">请先选择工作表</div>
      </template>
    </div>
  </div>
</template>
<script>
import Vue from 'vue'
import pageTab from '@/components/pageCom/pageTab'
import pageTable from '@/components/pageCom/pageTable'
import multiSearch from './components/multiSearch'
import filterCom from './components/filtersCom'

export default {
  name: 'singleClean',
  components: { pageTab, pageTable, multiSearch, filterCom },
  data() {
    return {
      tabs: [{
        text: '单条清洗',
        linkName: 'singleClean'
      }, {
        text: '不确定',
        linkName: 'unsureClean'
      }],
      fields: [], // 字段列表
      curTableId: '', // 当前的tableid
      curRuleId: '', // 当前的ruleid
      tableLoading: false, // 表格loading
      tableDataCount: 0, // 表格总数据
      tableCol: [], // 表格数据
      tableData: [], // 表格数据
      blockHeight: '300px',
      selArr: [] // 不确定页面的选中
    }
  },
  computed: {
    nowTab() {
      return this.$route.name
    },
    pageTitle() {
      if (this.$route.name === 'singleClean') {
        return '单条清洗'
      } else {
        return '不确定'
      }
    },
    pageType() {
      return this.$route.name
    },
    disableSel() {
      return this.pageType === 'unsureClean' && this.curRuleId === ''
    }
  },
  mounted() {
    this.init()
    this.blockHeight = document.body.offsetHeight - 280 + 'px'
  },
  watch: {
    $route() {
      this.init()
    }
  },
  methods: {
    // 初始化
    init() {
      this.$nextTick(() => {
        this.$refs.multiSearch && this.$refs.multiSearch.init()
        this.$refs.filterCom && this.$refs.filterCom.init()
        this.getFields()
        this.getTableData()
      })
    },
    // 更新工作表
    updateTable(tableId) {
      this.getFields()
      this.curTableId = tableId || ''
      this.getTableData()
    },
    // 更新规则
    updateRule(ruleId) {
      this.getFields()
      this.curRuleId = ruleId || ''
      this.getTableData()
    },
    // 获取当表的字段列表
    getFields() {
      setTimeout(() => {
        this.fields = [{
          name: '日期', type: '3', field: 'saleDate'
        }, {
          name: '客户类型', type: '2', field: 'custom'
        }, {
          name: '销售数量', type: '1', field: 'salesCount'
        }]
      })
    },
    // 筛选条件
    confirmFilter(filters) {
    },
    toggleFilterShow() {
      this.$refs.table.resize()
    },
    // 获取表格数据
    getTableData() {
      this.tableLoading = true
      setTimeout(() => {
        this.tableLoading = false
        this.tableDataCount = Math.floor(Math.random() * 100)
        this.tableCol = [
          { field: 'name', title: '姓名', width: 220, isResize: true, titleAlign: 'left', columnAlign: 'left' },
          { field: 'tel', title: '手机号码', width: 220, isResize: true, titleAlign: 'left', columnAlign: 'left' },
          { field: 'hobby', title: '爱好', width: 220, isResize: true, titleAlign: 'left', columnAlign: 'left' },
          { field: 'address', title: '地址', width: 220, isResize: true, titleAlign: 'left', columnAlign: 'left' }
        ]
        if (this.pageType === 'singleClean') {
          this.tableCol = [{ field: 'operate', title: '操作', width: 50, titleAlign: 'left', columnAlign: 'left', componentName: 'singleCleanOpe' }].concat(this.tableCol)
        } else if (this.pageType === 'unsureClean') {
          this.tableCol = [
            { width: 60, titleAlign: 'center', columnAlign: 'center', type: 'selection' },
            { field: 'operate', title: '操作', width: 50, titleAlign: 'left', columnAlign: 'left', componentName: 'singleCleanOpe' }
          ].concat(this.tableCol)
        }
        this.tableData = [
          { hasRule: this.curRuleId !== '', name: '赵伟', tel: '156*****1987', hobby: '钢琴、书法、唱歌', address: '上海市黄浦区金陵东路569号17楼' },
          { hasRule: this.curRuleId !== '', name: '赵伟', tel: '156*****1987', hobby: '钢琴、书法、唱歌', address: '上海市黄浦区金陵东路569号17楼' },
          { hasRule: this.curRuleId !== '', name: '赵伟', tel: '156*****1987', hobby: '钢琴、书法、唱歌', address: '上海市黄浦区金陵东路569号17楼' },
          { hasRule: this.curRuleId !== '', name: '赵伟', tel: '156*****1987', hobby: '钢琴、书法、唱歌', address: '上海市黄浦区金陵东路569号17楼' },
          { hasRule: this.curRuleId !== '', name: '赵伟', tel: '156*****1987', hobby: '钢琴、书法、唱歌', address: '上海市黄浦区金陵东路569号17楼' },
          { hasRule: this.curRuleId !== '', name: '赵伟', tel: '156*****1987', hobby: '钢琴、书法、唱歌', address: '上海市黄浦区金陵东路569号17楼' },
          { hasRule: this.curRuleId !== '', name: '赵伟', tel: '156*****1987', hobby: '钢琴、书法、唱歌', address: '上海市黄浦区金陵东路569号17楼' },
          { hasRule: this.curRuleId !== '', name: '赵伟', tel: '156*****1987', hobby: '钢琴、书法、唱歌', address: '上海市黄浦区金陵东路569号17楼' },
          { hasRule: this.curRuleId !== '', name: '赵伟', tel: '156*****1987', hobby: '钢琴、书法、唱歌', address: '上海市黄浦区金陵东路569号17楼' },
          { hasRule: this.curRuleId !== '', name: '赵伟', tel: '156*****1987', hobby: '钢琴、书法、唱歌', address: '上海市黄浦区金陵东路569号17楼' },
          { hasRule: this.curRuleId !== '', name: '赵伟', tel: '156*****1987', hobby: '钢琴、书法、唱歌', address: '上海市黄浦区金陵东路569号17楼' },
          { hasRule: this.curRuleId !== '', name: '赵伟', tel: '156*****1987', hobby: '钢琴、书法、唱歌', address: '上海市黄浦区金陵东路569号17楼' },
          { hasRule: this.curRuleId !== '', name: '赵伟', tel: '156*****1987', hobby: '钢琴、书法、唱歌', address: '上海市黄浦区金陵东路569号17楼' },
          { hasRule: this.curRuleId !== '', name: '赵伟', tel: '156*****1987', hobby: '钢琴、书法、唱歌', address: '上海市黄浦区金陵东路569号17楼' },
          { hasRule: this.curRuleId !== '', name: '赵伟', tel: '156*****1987', hobby: '钢琴、书法、唱歌', address: '上海市黄浦区金陵东路569号17楼' },
          { hasRule: this.curRuleId !== '', name: '赵伟', tel: '156*****1987', hobby: '钢琴、书法、唱歌', address: '上海市黄浦区金陵东路569号17楼' },
          { hasRule: this.curRuleId !== '', name: '赵伟', tel: '156*****1987', hobby: '钢琴、书法、唱歌', address: '上海市黄浦区金陵东路569号17楼' },
          { hasRule: this.curRuleId !== '', name: '赵伟', tel: '156*****1987', hobby: '钢琴、书法、唱歌', address: '上海市黄浦区金陵东路569号17楼' },
          { hasRule: this.curRuleId !== '', name: '赵伟', tel: '156*****1987', hobby: '钢琴、书法、唱歌', address: '上海市黄浦区金陵东路569号17楼' },
          { hasRule: this.curRuleId !== '', name: '赵伟', tel: '156*****1987', hobby: '钢琴、书法、唱歌', address: '上海市黄浦区金陵东路569号17楼' }
        ]
        if (this.disableSel) {
          this.tableData.map(item => {
            item._disabled = true
            return item
          })
        }
      }, 200)
    },
    // 不确定选中
    selectAll(selection) {
      this.selArr = selection
      if (this.disableSel) {
        this.$refs.table.clearSelect()
      }
    },
    // 不确定选中
    selectChange(selection, rowData) {
      this.selArr = selection
    },
    // 表格事件
    compFn(params) {
      if (params.type === 'restore') {
        this.restore([params.index])
      }
    },
    // 还原
    restore(arr) {
      setTimeout(() => {
        this.getTableData()
      }, 500)
    }
  }
}

// 自定义列组件
Vue.component('singleCleanOpe', {
  props: {
    rowData: Object,
    field: String,
    index: Number
  },
  computed: {
    pageType() {
      return this.$route.name
    }
  },
  methods: {
    edit() {
      if (this.rowData.hasRule) {
        if (this.pageType === 'singleClean') {
          this.$router.push({
            name: 'cleanList', params: { id: this.index }
          })
        } else {
          this.$emit('on-custom-comp', {
            type: 'restore',
            index: this.index
          })
        }
      }
    }
  },
  render: function(h) {
    return h('div', {
      class: ['link-btn', this.rowData.hasRule ? '' : 'link-btn--disabled'],
      on: {
        click: this.edit
      }
    }, this.pageType === 'singleClean' ? '编辑' : '还原')
  }
})
</script>
<style lang="scss" scoped="">
  .multi-search {
    position: absolute;
    right: 0;
    top: 0;
  }
  .no-table {
    height: 689px;
    padding-top: 120px;
    text-align: center;
    color: #B5C2D0;
  }
</style>
